/**
 * @features/dashboard/components/widgets/QuickActions.jsx
 * -------------------------------------------------------
 * Row of prominent CTAs. Each action is permission-gated automatically.
 *
 *   <QuickActions actions={[
 *     { label: "Add Property", to: "/dealer/add", perm: "property:create", icon: Tag },
 *     { label: "View Leads",   to: "/dealer/leads", perm: "lead:view-own", icon: Users },
 *   ]} />
 */

import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../lib/AuthContext";
import { can } from "../../config/permissions";

export function QuickActions({ actions = [] }) {
  const { user } = useAuth();
  const visible = actions.filter((a) => !a.perm || can(user, a.perm));
  if (!visible.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="quick-actions">
      {visible.map((a) => {
        const Icon = a.icon;
        return (
          <Link
            key={a.to}
            to={a.to}
            className="inline-flex items-center gap-2 px-3 py-2 bg-white border border-[#E4E4E7] hover:border-[#0055FF] text-[#27272A] hover:text-[#0055FF] text-[13px] font-medium rounded-sm transition-colors"
            data-testid={`quick-action-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {Icon ? <Icon size={14} /> : null}
            {a.label}
          </Link>
        );
      })}
    </div>
  );
}
